import React from 'react';


export function AlgorithmStep({index, children}) {

    return (
        <div className={"row rounded border py-3 mb-2 alg-step "  +(index % 2 === 0 ? "bg-light" : "bg-white")}>
            <div className={"col-2 d-flex justify-content-center text-center align-items-center "}>
                <div className={"border border-dark d-flex flex-column justify-content-center"} style={{borderRadius:"100%", minWidth:"2.5vw", minHeight:"2.5vw"}}>
                    <h3 className={"m-0 p-0"}>{index}</h3>
                </div>
            </div>
            <div className={"col pe-5"}>
                {children}
            </div>


        </div>


    );

}